var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import LocationMap from './LocationMap';
import LocationMapClasses from './LocationMap.less';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import Location from 'nucleus-widgets/lib/Location/Location';
import { resolveTestId, injectTestId } from '@cvent/nucleus-test-automation';
import { isAppleMap } from './LocationMapUtils';
var LocationMapWidget = /** @class */ (function (_super) {
    __extends(LocationMapWidget, _super);
    function LocationMapWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderNameAndAddressOverlay = function (styles) {
            var _a = _this.props, location = _a.location, _b = _a.address, address = _b === void 0 ? {} : _b, flexEventLocationMapType = _a.flexEventLocationMapType;
            var locationAddressClass = LocationMapClasses.locationText;
            if (isAppleMap(flexEventLocationMapType)) {
                locationAddressClass = LocationMapClasses.appleLocationText;
            }
            return (React.createElement("div", { className: locationAddressClass, style: styles.overlay },
                React.createElement(Location, __assign({}, injectTestId('location'), { style: { name: styles.name, address: styles.address }, location: location, address: address }))));
        };
        return _this;
    }
    LocationMapWidget.prototype.getStyleObject = function () {
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { name: this.getElementInlineStyle('location'), address: this.getElementInlineStyle('address'), overlay: this.getElementInlineStyle('overlayColor') });
    };
    LocationMapWidget.prototype.render = function () {
        var _a = this.props, googleApiKey = _a.googleApiKey, clickable = _a.clickable, _b = _a.address, address = _b === void 0 ? {} : _b, includeNameAndAddress = _a.config.includeNameAndAddress, translate = _a.translate, flexEventLocationMapType = _a.flexEventLocationMapType, appleMapToken = _a.appleMapToken;
        var styles = this.getStyleObject();
        return (React.createElement("div", __assign({}, resolveTestId(this.props), { className: LocationMapClasses.container, style: styles.container }),
            React.createElement("div", { className: LocationMapClasses.absolutePositioningParent },
                includeNameAndAddress && this.renderNameAndAddressOverlay(styles),
                React.createElement(LocationMap, __assign({}, injectTestId('location-map'), { translate: translate, googleApiKey: googleApiKey, clickable: clickable, address: address, flexEventLocationMapType: flexEventLocationMapType, appleMapToken: appleMapToken })))));
    };
    LocationMapWidget.displayName = 'LocationMapWidget';
    LocationMapWidget.propTypes = {
        config: PropTypes.shape({
            includeNameAndAddress: PropTypes.bool
        }),
        style: PropTypes.object,
        translate: PropTypes.func,
        googleApiKey: PropTypes.string.isRequired,
        clickable: PropTypes.bool,
        location: PropTypes.string,
        address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            address3: PropTypes.string,
            city: PropTypes.string,
            stateCode: PropTypes.string,
            postalCode: PropTypes.string,
            countryCode: PropTypes.string
        }),
        flexEventLocationMapType: PropTypes.number,
        appleMapToken: PropTypes.string.isRequired
    };
    return LocationMapWidget;
}(BaseWidget));
export default LocationMapWidget;
